import { Events } from 'src/constants/webSocketConsts/events';
import {
  BuilderSession,
  builderSessionApi,
  ListBuilderSessionsResponse,
} from 'src/services/api/builderSessionApi';
import { AppDispatch } from 'src/store/configureStore';

const isBuilderSession = (item: unknown): item is BuilderSession =>
  typeof item === 'object' &&
  item !== null &&
  typeof (item as { id?: unknown }).id === 'string' &&
  typeof (item as { appBuilderId?: unknown }).appBuilderId === 'string';

export function handleBuilderSessionUpdate(
  event: Events,
  items: unknown[],
  dispatch: AppDispatch,
) {
  if (event !== Events.Insert && event !== Events.Modify) {
    return;
  }

  const sessions = items.filter(isBuilderSession);
  if (sessions.length === 0) {
    return;
  }

  for (const rawSession of sessions) {
    const session: BuilderSession =
      'activeTurnId' in rawSession
        ? rawSession
        : { ...rawSession, activeTurnId: undefined };

    dispatch(
      builderSessionApi.util.updateQueryData(
        'getBuilderSession',
        { appBuilderId: session.appBuilderId, sessionId: session.id },
        (draft: BuilderSession) => {
          Object.assign(draft, session);
        },
      ),
    );

    dispatch(
      builderSessionApi.util.updateQueryData(
        'listBuilderSessions',
        { appBuilderId: session.appBuilderId },
        (draft: ListBuilderSessionsResponse) => {
          const idx = draft.data.findIndex((s) => s.id === session.id);
          if (idx !== -1) {
            Object.assign(draft.data[idx], session);
          }
        },
      ),
    );
  }
}
